<form [formGroup]="collaborationGroup" class="flex flex-col">

  <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
    <mat-icon class="icon-small mr1">add_circle_outline</mat-icon>
    <span translate="">Add collaboration members</span>
  </h3>

  <mat-form-field appearance="outline">
    <mat-icon matPrefix="" class="mr1">search</mat-icon>
    <mat-label translate="">Search for a person or company</mat-label>
    <input matInput="" type="text" [formControl]="searchMemberControl" [matAutocomplete]="auto" autocomplete="off">
    <div matSuffix="" class="flex items-center">
      @if (searchMemberControlIsLoading) {
        <mat-spinner diameter="24" class="mx2"></mat-spinner>
      }
    </div>
  </mat-form-field>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchValue" (optionSelected)="addMember($event)" class="small-autocomplete">
    @if (!searchMemberControlIsLoading) {
      @if (searchMemberControl.value && filteredMembers && filteredMembers.length == 0) {
        <mat-option>
          <span class="main bold black" translate="">Nothing found</span>
        </mat-option>
      }
      @for (filteredMember of filteredMembers; track filteredMember) {
        <mat-option [value]="filteredMember" class="flex justify-between content-center items-center flex-row flex-wrap">
          @if (filteredMember.type == 'Company') {
            <mat-icon class="icon-small">business_center</mat-icon>
          }
          @if (filteredMember.type == 'Person') {
            <mat-icon class="icon-small">person_outline</mat-icon>
          }
          <span class="main bold black ">{{ filteredMember.name }}</span>
          @if (filteredMember.address) {
            <span class="sub ml2">{{filteredMember.address.addressLine1}}, {{filteredMember.address.city}}</span>
          }
          @if (!filteredMember.address) {
            <span class="sub ml2" translate="">Unknown</span>
          }
        </mat-option>
      }
    }
  </mat-autocomplete>

  <mat-list class="boxed-list mb1">
    @for (member of members; track member) {
      <mat-list-item>
        @if (member.type == 'Company') {
          <mat-icon matListItemIcon="">business_center</mat-icon>
        }
        @if (member.type == 'Person') {
          <mat-icon matListItemIcon="">person_outline</mat-icon>
        }
        <h4 mat-line="" class="mat-headline-6">
          {{member.name}}
        </h4>
        <p mat-line="" class="flex justify-start content-center items-center flex-row">
          <span class="gray mr1" translate="">Share</span>
          <strong class="mr1">{{member.share}}%</strong>
          <button mat-icon-button="" (click)="changeShare(member, member.share -.5)">
            <mat-icon>expand_more</mat-icon>
          </button>
          <button mat-icon-button="" (click)="changeShare(member, member.share + .5)">
            <mat-icon>expand_less</mat-icon>
          </button>
        </p>
        <button mat-icon-button="" color="warn" (click)="removeMember(member)">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-list-item>
    }
  </mat-list>

  <h3 class="mat-headline-6 mt3 flex flex-row justify-start items-center w-full">
    <mat-icon class="icon-small mr1">list_alt</mat-icon>
    <span translate="">Collaboration information</span>
  </h3>

  <mat-form-field appearance="outline" class="small-field">
    <mat-label translate="">Name</mat-label>
    <input matInput="" type="text" formControlName="name" minlength="1" required="" autocomplete="off">
  </mat-form-field>

  <unite-address-input-v2 class="mt2 flex flex-col" formGroupName="address">
    <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
      <mat-icon class="icon-small mr1">place</mat-icon>
      <span translate="">Address</span>
    </h3>
  </unite-address-input-v2>

  <h3 class="mat-headline-6 mt2 flex flex-row justify-start items-center w-full">
    <mat-icon class="icon-small mr1">phone_iphone</mat-icon>
    <span translate="">Contact information</span>
  </h3>
  <div class="flex flex-row space-x-[3%] basis-full">
    <mat-form-field appearance="outline" class="basis-1/2">
      <mat-label translate="">Telephone</mat-label>
      <input matInput="" type="text" formControlName="phone" autocomplete="off" pattern="((\+\d{8,14})|([0]\d{9}))">
    </mat-form-field>

    <mat-form-field appearance="outline" class="basis-1/2">
      <mat-label translate="">Mobile</mat-label>
      <input matInput="" type="text" formControlName="mobile" autocomplete="off" pattern="((\+\d{8,14})|([0]\d{9}))">
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline">
    <mat-label translate="">Email</mat-label>
    <input matInput="" email="" type="email" formControlName="email" autocomplete="off">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label translate="">IBAN</mat-label>
    <input matInput="" type="text" formControlName="iban" autocomplete="off">
  </mat-form-field>

  <unite-customer-settings [userControl]="collaborationGroup.get('adviser')" [existingControl]="collaborationGroup.get('existing')" [isCreating]="true" [businessunitControl]="collaborationGroup.get('businessunit')">
  </unite-customer-settings>

  <div class="mt3 flex flex-row justify-end content-center items-center w-full">
    <unite-loading-button [text]="'Add collaboration' | translate" [loading]="loadingCreate" icon="done" (buttonClick)="create()"></unite-loading-button>
  </div>
</form>